import Vue from 'vue/dist/vue.esm.js';

Vue.component('search-autocomplete', {
    template: `#search-autocomplete`,
    delimiters: ['[[', ']]'],
    props: {
        locale: {
            required: true,
            type: String,
        },
        currency: {
            required: true,
            type: String,
        },
        searchUrl: {
            required: true,
            type: String,
        },
        searchPageUrl: {
            required: true,
            type: String,
        },
    },

    mounted() {

    },

    data() {
        return {
            results: [],
            term: '',
            timeout: 0,
            enterTimeout: null,
            moreResultCount: 0,
            isLoading: false,
            request: false,
            isDropdownVisible: false,
            lastInputTime: 0,
            blockEnter: false,
        }
    },

    methods: {
        documentOnClick() {
            this.hide();
        },
        show() {
            this.isDropdownVisible = true;
            document.addEventListener("click", this.documentOnClick);
        },
        hide() {
            this.isDropdownVisible = false;
            document.removeEventListener("click", this.documentOnClick);
        },
        inputOnClick(e){
            e.stopPropagation();
        },
        containerOnClick(e){
            e.stopPropagation();
        },
        onFocus(){
            this.show();
        },

        onInput() {
            const now = Date.now();
            if (now - this.lastInputTime < 50) {
                this.blockEnter = true;

                clearTimeout(this.enterTimeout);
                this.enterTimeout = setTimeout(() => {
                    this.blockEnter = false;
                }, 1000);
            }

            this.lastInputTime = now;

            this.isLoading = true;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(this.search, 300);
        },

        onEnter(e) {
            if (this.blockEnter) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        },

        search() {
            this.results = [];
            let _self = this;

            if (this.term === '') {
                return;
            }
            if(this.request){
                this.request.abort();
            }
            if(!this.isDropdownVisible){
                this.show();
            }

            this.request = $.ajax({
                data: {term: _self.term},
                url: _self.searchUrl,
                method: 'GET',
                success: function (result) {
                    _self.isLoading = false;
                    _self.results = result.products;
                    _self.moreResultCount = result.moreResultCount;
                },
            });
        },

        formattedPrice(price) {
            return new Intl.NumberFormat(this.locale, {style: 'currency', currency: this.currency}).format(price).replace(',','.');
        },

    },

    computed: {
        fullSearchUrl() {
            return this.searchPageUrl + '?term=' + this.term;
        }
    }
});